/**
 * postMessage 安全校验工具
 *
 * 治理背景：CommonMenu / CommonIframePage 监听 window 'message' 时未校验
 * event.origin，任何来源页面均可伪造 CHANGE_MENU / CHANGE_LOCATION 消息，
 * 导致任意 URL 路由跳转 + open redirect（CWE-840）。
 */

/**
 * 拦截开关。立刻上线版本：直接拦截非法 origin。
 * 若线上出现 "iframe 内系统切换菜单失败" 的误伤反馈，先临时改回 true
 * 止血，再把对应 origin 补进白名单后恢复 false。
 */
const OBSERVE_ONLY = false;

/** 允许 postMessage 的来源（完整 origin，精确匹配） */
const TRUSTED_ORIGINS = new Set<string>([
  window.location.origin,
]);

/** 允许的集团域名后缀（被嵌入的子系统都在集团域名下） */
const TRUSTED_HOST_SUFFIXES = [
  '.jd.com',
  '.jd.cn',
  '.jdl.com',
  '.jdl.cn',
  '.jdcloud.com',
  '.jdlcs.com',
];

export const isTrustedOrigin = (origin: string): boolean => {
  if (TRUSTED_ORIGINS.has(origin)) return true;
  try {
    const { hostname } = new URL(origin);
    return TRUSTED_HOST_SUFFIXES.some(
      (suffix) => hostname === suffix.slice(1) || hostname.endsWith(suffix),
    );
  } catch {
    return false;
  }
};

/**
 * postMessage origin 守卫
 *
 * @returns true 表示放行；false 表示应忽略该消息
 *
 * OBSERVE_ONLY = true：非法 origin 只打告警日志并放行（灰度收集）
 * OBSERVE_ONLY = false：非法 origin 直接拒绝
 */
export const guardPostMessageOrigin = (
  origin: string,
  eventName?: string,
): boolean => {
  if (isTrustedOrigin(origin)) return true;

  // 日志用于上线后发现误伤时定位真实 origin，以便补白名单
  console.warn('[postMessage] untrusted origin:', origin, eventName);
  (window as { clstag?: (key: string, value: string) => void }).clstag?.(
    'postmessage_untrusted_origin',
    origin,
  );

  return OBSERVE_ONLY;
};
